import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { CSSProperties, Image, TabItem } from '@com-delta-idp/mnx-ui-kit';
import {
  OfferBannerConfig,
  Orientation
} from '../../pages/fast-action-banner-page/models/ui.interfaces';

@Component({
  selector: 'idp-offer-details-banner',
  templateUrl: './offer-details-banner.component.html',
  styleUrls: ['./offer-details-banner.component.scss'],
  encapsulation: ViewEncapsulation.None // added to update styles for child comp-tab-navigation
})
export class OfferDetailsBannerComponent {
  @Input() benefit = '';
  @Input() benefitStyles: CSSProperties = {} as CSSProperties;
  @Input() containerStyles: CSSProperties = {} as CSSProperties;
  @Input() details = '';
  @Input() detailsStyles: CSSProperties = {} as CSSProperties;
  @Input() fee = '';
  @Input() feeStyles: CSSProperties = {} as CSSProperties;
  @Input() headline = '';
  @Input() headlineStyles: CSSProperties = {} as CSSProperties;
  @Input() image: Image | undefined = {} as Image;
  @Input() imageStyles: CSSProperties = {} as CSSProperties;
  @Input() links: TabItem[] = [];
  @Input() linksStyles: CSSProperties = {} as CSSProperties;
  @Input() offer: string | null = '';
  @Input() offerStyles: CSSProperties = {} as CSSProperties;
  @Input() config: OfferBannerConfig = {} as OfferBannerConfig;
  @Input() orientation: Orientation = 'horizontal';
  @Input() displaySecondaryHeader = false;
  @Output() openLink = new EventEmitter<TabItem>();

  changeTab(selectedLink: TabItem) {
    this.openLink.emit(selectedLink);
  }
}
